import { DiCodeigniter } from "react-icons/di";
import { AiFillAndroid, AiOutlineDotNet } from "react-icons/ai";
import { BsCloudCheck, BsDatabaseLock, BsRobot, BsUnity, BsVectorPen } from "react-icons/bs";
import { FaAdversal, FaAngular, FaGlobe, FaLaravel, FaLocationArrow, FaMagento, FaMobile, FaNode, FaReact, FaShopify, FaSymfony, FaVuejs, FaWordpress } from "react-icons/fa";
import {
  FiBarChart2,
  FiBookOpen,
  FiGlobe,
  FiGrid,
  FiLayout,
  FiMail,
  FiMessageCircle,
  FiMonitor,
  FiPenTool,
  FiPlayCircle,
  FiRefreshCw,
  FiSearch,
  FiSmartphone,
  FiTerminal,
  FiTool,
  FiZap,
  FiMapPin,
  FiCalendar,
  FiMessageSquare,
  FiAward,
  FiTrendingUp,
  FiEdit3,
  FiCpu,
} from "react-icons/fi";
import { LuTarget, LuMegaphone, LuVideo } from "react-icons/lu";

import { GrOverview } from "react-icons/gr";
import { RiNextjsFill } from "react-icons/ri";
import { MdConnectedTv } from "react-icons/md";
import { GiCpu, GiLifeInTheBalance } from "react-icons/gi";
import { IoLogoApple, IoLogoIonic } from "react-icons/io";
import { IoLayersSharp, IoLogoPwa } from "react-icons/io5";
import { TbBrandFlutter, TbDeviceIpad } from "react-icons/tb";
import { SiBlockchaindotcom, SiBrandfetch, SiCoinmarketcap, SiDjango, SiPayloadcms, SiSolid, SiWoo } from "react-icons/si";

export const NAV_LINKS = [
  { label: "Services", href: "#services", hasDropdown: true, dropdown: "services" },
  { label: "Success Stories", href: "/success-stories" },
  { label: "Careers", href: "/career" },
  { label: "Blogs", href: "/blogs" },
  { label: "About Us", href: "#aboutUs", hasDropdown: true, dropdown: "about" },
  { label: "Global Events", href: "/attended-event-worldwide" },
  { label: "Feedback", href: "/clients-feedback" },
];

export const SERVICES_DROPDOWN = [
  {
    label: "Trending Technologies",
    href: "/trending-technologies-services-india",
    icon: <SiBlockchaindotcom size={22} />,
    subLinks: [
      { label: "AI & Machine Learning ", href: "/ai-ml-development-services-india", icon: <BsRobot size={20} /> },
      { label: "Blockchain Development ", href: "/blockchain-development-services-india", icon: <BsDatabaseLock size={20} /> },
      { label: "AR App Development ", href: "/ar-app-development-services-india", icon: <BsVectorPen size={20} /> },
      { label: "VR App Development ", href: "/vr-app-development-services-india", icon: <BsUnity size={20} /> },
      { label: "Cloud & DevOps ", href: "/devops-cloud-development-services-india", icon: <BsCloudCheck size={20} /> },
    ],
  },
  // {
  //   label: "Ai Services",
  //   href: "/agentic-ai-development-services-india",
  //   icon: <GiCpu size={22} />,
  //   subLinks: [{ label: "AI & Machine Learning ", href: "/ai-ml-development-services-india", icon: <BsRobot size={20} /> }],
  // },
  {
    label: "Mobile Apps",
    href: "/mobile-app-development-services-india",
    icon: <FaMobile className="text-[var(--c-success)]" size={18} />,

    subLinks: [
      { label: "Android Development", href: "/android-app-development-services-india", icon: <AiFillAndroid size={20} /> },
      { label: "iOS Development", href: "/ios-app-development-services-india", icon: <IoLogoApple size={20} /> },
      { label: "Hybrid Apps", href: "/hybrid-app-development-services-india", icon: <IoLayersSharp size={20} /> },
      { label: "iPad Apps", href: "/ipad-app-development-services-india", icon: <TbDeviceIpad size={20} /> },
      { label: "OTT Apps", href: "/ott-platform-development-services-india", icon: <MdConnectedTv size={20} /> },
      { label: "Flutter App Development", href: "/flutter-app-development-services-india", icon: <TbBrandFlutter size={20} /> },
      { label: "Ionic App Development", href: "/ionic-app-development-services-india", icon: <IoLogoIonic size={20} /> },
      { label: "React Native Development", href: "/react-native-app-development-services-india", icon: <FaReact size={20} /> },
      { label: "PWA Development", href: "/pwa-development-services-india", icon: <IoLogoPwa size={20} /> },
    ],
  },
  {
    label: "Web Development",
    href: "/web-app-development-services-india",
    icon: <FaGlobe color="#00b4d8" size={22} />,
    subLinks: [
      { label: "React Development", href: "/reactjs-development-services-india", icon: <FaReact size={20} /> },
      { label: "Angular Development", href: "/angular-development-services-india", icon: <FaAngular size={20} /> },
      { label: "Vue JS Development", href: "/vuejs-development-services-india", icon: <FaVuejs size={20} /> },
      { label: "Solid JS Development", href: "/solidjs-development-services-india", icon: <SiSolid size={20} /> },
      { label: "Next.js Development", href: "/nextjs-development-services-india", icon: <RiNextjsFill size={20} /> },
      { label: "NodeJS Development", href: "/nodejs-development-services-india", icon: <FaNode size={20} /> },
      { label: ".NET Development", href: "/dotnet-development-services-india", icon: <AiOutlineDotNet size={20} /> },
      { label: "Symfony Development", href: "/symfony-development-services-india", icon: <FaSymfony size={20} /> },
      { label: "Laravel Development", href: "/laravel-development-services-india", icon: <FaLaravel size={20} /> },
      { label: "Codeigniter Development", href: "/codeigniter-development-services-india", icon: <DiCodeigniter size={20} /> },
      { label: "Django Development", href: "/django-development-services-india", icon: <SiDjango size={20} /> },
    ],
  },
  {
    label: "Digital Marketing",
    href: "/digital-marketing-services-india",
    icon: <SiCoinmarketcap color="orange" size={22} />,
    subLinks: [
      { label: "Growth Analytics & AI", href: "/growth-analytics-ai-services-india", icon: <FiBarChart2 size={20} /> },
      { label: "SEO & Content Strategy", href: "/seo-content-strategy-services-india", icon: <FiSearch size={20} /> },
      { label: "Social Media Marketing", href: "/social-media-marketing-services-india", icon: <FiMessageCircle size={20} /> },
      { label: "Email & Automation", href: "/email-automation-services-india", icon: <FiMail size={20} /> },
      { label: "Web3 Community Building", href: "/web3-community-building-services-india", icon: <FiGlobe size={20} /> },
      { label: "PPC & Paid Advertising", href: "/ppc-paid-advertising-services-india", icon: <FiBookOpen size={20} /> },
      { label: "Branding Services", href: "/branding-services-india", icon: <SiBrandfetch size={20} /> },
      { label: "Brand Strategy & Positioning", href: "/brand-strategy-positioning-services-india", icon: <LuTarget size={20} /> },
      { label: "Brand Positioning & Promotion", href: "/brand-positioning-promotion-services-india", icon: <LuMegaphone size={20} /> },
      { label: "Content Marketing Services", href: "/content-marketing-services-india", icon: <FiEdit3 size={20} /> },
      { label: "Organic Growth Content Marketing", href: "/organic-growth-content-marketing-services-india", icon: <FiTrendingUp size={20} /> },
      { label: "Ad Campaign Management", href: "/ad-campaign-management-services-india", icon: <FaAdversal size={20} /> },
      { label: "Performance Marketing & Paid Media", href: "/performance-marketing-paid-media-services-india", icon: <FiBarChart2 size={20} /> },
      { label: "Generative Engine Opt (GEO)", href: "/generative-engine-optimization-services-india", icon: <FiCpu size={20} /> },
      { label: "Answer Engine Opt (AEO)", href: "/answer-engine-optimization-services-india", icon: <FiMessageSquare size={20} /> },
      { label: "ChatGPT Ads Services", href: "/chatgpt-advertising-services-india", icon: <LuTarget size={20} /> },
      { label: "Agentic AI Development Services", href: "/agentic-ai-development-services-india", icon: <GiCpu size={20} /> },
    ],
  },
  {
    label: "UI/UX & Design",
    href: "/ui-ux-design-services-india",
    icon: <FiPenTool className="text-[var(--c-danger)]" size={22} />,
    subLinks: [
      { label: "UX Research & Strategy", href: "/ux-research-strategy-india", icon: <FiSearch size={20} /> },
      { label: "Video Editing Services", href: "/video-editing-services-india", icon: <LuVideo size={20} /> },
      { label: "Wireframing & Prototyping", href: "/wireframing-prototyping-india", icon: <FiLayout size={20} /> },
      { label: "UI Design & Design Systems", href: "/ui-design-systems-india", icon: <FiGrid size={20} /> },
      { label: "Mobile App Design", href: "/mobile-app-design-india", icon: <FiSmartphone size={20} /> },
      { label: "Web & SaaS Dashboard Design", href: "/web-SaaS-dashboard-design-india", icon: <FiMonitor size={20} /> },
      { label: "Usability Testing & Optimization", href: "/usability-testing-iteration-india", icon: <FiRefreshCw size={20} /> },
    ],
  },

  {
    label: "eCommerce & CMS",
    href: "/ecommerce-cms-services-india",
    icon: <SiPayloadcms color="green" size={22} />,
    subLinks: [
      { label: "Magento  Development", href: "/magento-development-india", icon: <FaMagento size={20} /> },
      { label: "Shopify Store Development", href: "/shopify-development-india", icon: <FaShopify size={20} /> },
      { label: "WooCommerce  Development", href: "/woocommerce-development-india", icon: <SiWoo size={20} /> },
      { label: "WordPress CMS Development", href: "/wordpress-development-india", icon: <FaWordpress size={20} /> },
    ],
  },

  {
    label: "Testing & Maintenance",
    href: "/testing-and-maintenance-services-india",
    icon: <FiTool className="text-[var(--c-brand)]" size={22} />,
    subLinks: [
      { label: "Automated Testing", href: "/automated-regression-testing-india", icon: <FiPlayCircle size={20} /> },
      { label: "Security & Penetration Testing", href: "/security-testing-india", icon: <FiTerminal size={20} /> },
      { label: "Performance & Load Testing ", href: "/performance-testing-india", icon: <FiZap size={20} /> },
    ],
  },

  {
    label: "Geofencing",
    href: "/geofencing-marketing-services-india",
    icon: <FiMapPin className="text-[var(--c-brand)]" size={20} />,
    subLinks: [
      { label: "Event Marketing", href: "/event-management-brand-promotion-services-india", icon: <FiCalendar size={20} /> },
      { label: "Location Activations", href: "/location-based-experiential-marketing-services-india", icon: <FaLocationArrow size={15} /> },
      { label: "Onsite Survey Intelligence", href: "/onsite-surveys-feedback-intelligence-services-india", icon: <FiMessageSquare size={20} /> },
    ],
  },
];

export const ABOUTUS_DROPDOWN = [
  {
    label: "Company Overview",
    href: "/about-us",
    icon: <GrOverview className="text-[var(--c-success)]" size={22} />,
    desc: "Who we are and what drives us",
  },
  {
    label: "Life @ Tycho",
    href: "/life-at-tycho",
    icon: <GiLifeInTheBalance color="#00b4d8" size={22} />,
    desc: "Culture, team and our work environment",
  },
];
